import { useSite } from "@/lib/site";
import { PageHeader, Reveal } from "@/components/site/common";
import { PriceCard } from "@/components/site/Pricing";
import { CtaBand } from "@/components/site/Sections";
import { ReviewsGrid } from "@/components/site/Reviews";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQ = [
  ["Is ad spend included in the price?", "No. Ad spend for Google and Meta campaigns is separate and paid directly to the platform. Our price covers strategy, setup and management."],
  ["How do I pay?", "Pay securely with PayPal. While our PayPal checkout is being activated, tap Pay now and request a PayPal invoice — we'll send it the same day."],
  ["What happens after I buy?", "We start with a discovery call, agree on deliverables and a timeline, then get to work. No surprises."],
  ["Can I get a custom quote?", "Yes. If your project doesn't fit a package, send us a message or start a chat and we'll put together a proposal."],
];

export default function Pricing() {
  const { packages } = useSite();
  return (
    <>
      <PageHeader overline="Pricing" title="Clear prices. No guesswork." testid="pricing-header">
        Pick a package and pay online in minutes, or talk to us first. All prices are in USD.
      </PageHeader>
      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-24">
        <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-5 items-stretch" data-testid="pricing-grid">
          {packages.map((p, i) => <Reveal key={p.id} delay={i * 0.06} className="h-full"><PriceCard pkg={p} featured={p.id === "google-ads-management"} /></Reveal>)}
        </div>
      </section>
      <ReviewsGrid />
      <section className="max-w-3xl mx-auto px-5 sm:px-8 pb-12">
        <p className="overline mb-4">Questions</p>
        <h2 className="font-display text-3xl font-extrabold tracking-tight mb-6">Before you buy</h2>
        <Accordion type="single" collapsible data-testid="pricing-faq">
          {FAQ.map(([q, a], i) => (
            <AccordionItem key={q} value={`q${i}`}>
              <AccordionTrigger className="text-left font-display font-semibold text-base" data-testid={`pricing-faq-${i}`}>{q}</AccordionTrigger>
              <AccordionContent className="text-slate-600">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
      <CtaBand />
    </>
  );
}
